import { useCallback, useEffect, useState } from 'react';
import { TreatmentTemplate, GetVideoVisitTemplateParams } from 'types/treatmentTemplate';
import { getTreatmentTemplates } from 'api/videoSetting';

const useGetTreatmentTemplates = (params?: GetVideoVisitTemplateParams, autoFetch = false): [TreatmentTemplate[], number, boolean, (p: GetVideoVisitTemplateParams) => void] => {
    const [data, setData] = useState<TreatmentTemplate[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetch = useCallback(async (p: GetVideoVisitTemplateParams) => {
        setLoading(true);
        try {
            const result = await getTreatmentTemplates(p);
            if (result && !result.error) {
                const { list = [], totalRecords: totalCount = 0 } = result.data?.data || {};
                setData(list);
                setTotal(totalCount);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        if (params && autoFetch) {
            fetch(params);
        }
    }, [fetch, params]);

    return [data, total, loading, fetch];
};

export default useGetTreatmentTemplates;
